import axios from 'axios';

export default (id, payload) => {
  const promise = new Promise((resolve, reject) => {
    let params = payload || {};
    axios
      .delete(process.env.VUE_APP_API_ADMIN_LOCATION + `reviews/${id}`, {
        params,
      })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
